export default "__VITE_ASSET__cFzjhOz9__"